// extracted by mini-css-extract-plugin
export var contentWrapper = "LandingCardWithList-module--contentWrapper--c9ec8";
export var media = "LandingCardWithList-module--media--00a66";
export var wrapper = "LandingCardWithList-module--wrapper--7568c";